<template>
    <div class="bg_main">
    <v-container>
        <v-card class="card-orders-list">
                <v-card-title class="pb-0 justify-center">Cambio de contraseña</v-card-title>
                <v-divider class="mt-2"></v-divider>
            <v-card-text>
                <v-form ref="formPasswords" v-model="formValid">
                    <v-container>
                        <v-row class="mb-4">
                            <v-col cols="12" lg="6" offset-lg="3">
                                <v-text-field
                                        :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[formValidator.password.required, formValidator.password.min]"
                                        :type="showCurrentPassword ? 'text' : 'password'"
                                        label="* Contraseña actual"
                                        placeholder="Escribe tu contraseña actual."
                                        @click:append="showCurrentPassword = !showCurrentPassword"
                                        outlined required
                                        v-model="passwordRequest.current_password"
                                ></v-text-field>
                                <v-divider class="my-2"></v-divider>
                            </v-col>

                            <v-col cols="12" lg="6" offset-lg="3">
                                <v-text-field
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.required, formValidator.password.min]"
                                    :type="showPassword ? 'text' : 'password'"
                                    label="* Ingresa tu nueva contraseña"
                                    placeholder="Escribe la nueva contraseña."
                                    hint="Ingresa una contraseña que puedas recordar con facilidad."
                                    @click:append="showPassword = !showPassword"
                                    outlined required
                                    v-model="passwordRequest.password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" offset-lg="3">
                                <v-text-field
                                    :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.passwordMatch(passwordRequest.confirm_password, passwordRequest.password)]"
                                    :type="showRepeatPassword ? 'text' : 'password'"
                                    label="* Confirma tu contraseña"
                                    placeholder="Escribe la misma contrseña del campo anterior"
                                    @click:append="showRepeatPassword = !showRepeatPassword"
                                    outlined required
                                    v-model="passwordRequest.confirm_password"
                                ></v-text-field>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn color="error" class="mx-2" link :to="{name: 'home'}" large>
                                    Cancelar
                                </v-btn>
                                <v-btn color="primary" class="mx-2" large @click="submitForm()">
                                    Aplicar cambios
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

        </v-card>
    </v-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import registerFormValidator from "@/form/register.form.validator";

export default {
    name: "PasswordUpdate",

    data() {
        return {
            formValid: false,

            showPassword: false,
            showRepeatPassword: false,
            showCurrentPassword: false,
            formValidator: registerFormValidator,

            passwordRequest: {
                password: '',
                confirm_password: '',
                current_password: ''
            }

        }
    },

    computed: {
        ...mapState({accountStore: state => state.account})
    },

    methods: {
        ...mapActions('account', ['changeAccountPassword']),

        submitForm(){
            this.$refs.formPasswords.validate()

            if (this.formValid){
                //VueX
                this.changeAccountPassword(this.passwordRequest)
            }
        }

    },
}
</script>

<style scoped>


    .card-orders-list {
        min-height: 85vh;
    }
</style>